export default __webpack_public_path__ + "static/media/print_icon.1b2165a7.svg";